import React from 'react'
import {
  UserKeyBody,
  UserKeyBottomBorder,
  UserKeyHeader,
  UserKeyIcon,
  UserKeySelectorContainer,
  UserKeyTitle,
  UserKeyWrapper,
} from './styles'
import PropTypes from 'prop-types'
import RightSlinArrow from '../../../images/pix-ping/slin_arrow_right.svg'
import { Image } from '../image'

const UserKeySelector = (props) => {
  const { userKeyIcon, title, onClick } = props

  return (
    <>
      <UserKeyWrapper onClick={onClick}>
        <UserKeySelectorContainer>
          <UserKeyHeader>
            <UserKeyIcon>
              <Image url={userKeyIcon} alt={title} />
            </UserKeyIcon>
            <UserKeyTitle>{title}</UserKeyTitle>
          </UserKeyHeader>
          <UserKeyBody>
            <Image url={RightSlinArrow} alt={title} />
          </UserKeyBody>
        </UserKeySelectorContainer>
      </UserKeyWrapper>
      <UserKeyBottomBorder />
    </>
  )
}

UserKeySelector.propTypes = {
  userKeyIcon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default UserKeySelector
